// extracted by mini-css-extract-plugin
export default {"container":"ClinicCard_container__M1cnn","doctorsSection":"ClinicCard_doctorsSection__FEk5Z"};